"use client"
import { createTheme} from '@mui/material';
import { ThemeProvider } from 'styled-components';
import Organizationtable from '../../components/ManageOrganization/Organizationtable';
const defaultTheme = createTheme();
const ManageOrganization = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <Organizationtable />
    </ThemeProvider>
  )
}

export default ManageOrganization